import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SeoContent from '../components/SeoContent';
import PageSEO from '../components/PageSEO';
import ShareModal from '../components/ShareModal';

// ─── Word Database ────────────────────────────────────────────────────────────
const NOUNS = [
  // short (≤4)
  'ace','age','arc','art','bay','bee','bud','bug','cab','cup','dew','dot','eve',
  'fog','gem','hue','ink','ivy','jam','jar','jet','joy','key','kid','lab','law',
  'lid','map','mob','mud','net','oak','orb','owl','pad','pie','pit','pod','pub',
  'ray','rib','rod','sea','sky','spa','tag','tub','urn','web','wit',
  // medium (5–8)
  'agent','album','angel','angle','arena','atlas','attic','badge','beard','bench',
  'bloom','board','brace','brand','bread','brook','cabin','candy','cedar','chalk',
  'chart','chief','claim','cloud','clown','coach','comet','creek','crest','daisy',
  'dance','debut','delta','depot','dream','drift','eagle','epoch','essay','event',
  'fable','feast','field','flame','flask','flood','flour','flute','focus','forge',
  'forum','frame','frost','ghost','giant','grace','grain','greed','grief','grove',
  'guild','haven','holly','horde','image','jewel','laser','lemon','light','lotus',
  'magic','maple','mercy','model','mouse','nerve','novel','nymph','olive','opera',
  'orbit','ozone','panel','paper','pasta','peace','phase','piano','pilot','pixel',
  'pizza','plank','plaza','plume','poppy','porch','power','prism','prize','probe',
  'pulse','quest','quill','quota','radar','radio','rally','raven','realm','relic',
  'ridge','rivet','robin','robot','rouge','rover','ruler','saint','salsa','sauce',
  'scope','shade','shaft','sheep','shelf','shell','shore','shrub','slate','smoke',
  'snake','spark','spell','spice','spine','squad','steel','sting','stork','sugar',
  'suite','swamp','sword','syrup','table','tiger','torch','tower','tribe','truce',
  'tulip','ultra','union','valor','valve','vapor','venom','verse','viola','viper',
  'vocal','vogue','waltz','watch','whale','wheat','wheel','wrath','yacht','youth','zebra',
  // long (9+)
  'absence','alchemy','almanac','ambiance','antique','anxiety','ballpark','banquet',
  'bastion','benefit','blossom','boundary','boutique','brevity','brigade','cabinet',
  'calendar','cascade','cavern','century','clarity','cluster','comfort','compass',
  'concept','costume','crescent','crystal','culture','dynasty','ecology','edifice',
  'episode','essence','faction','fantasy','farewell','finance','forecast','fortune',
  'freedom','galleon','gallery','glacier','glamour','grandeur','gravity','harvest',
  'heritage','horizon','illusion','journey','justice','lantern','lineage','loyalty',
  'mandate','mansion','mastery','miracle','mission','mixture','monarch','mountain',
  'mystery','network','nirvana','obstacle','outcome','paradise','passion','patience',
  'pattern','pilgrim','pioneer','plateau','poverty','purpose','remnant','reserve',
  'respect','revenue','rivalry','sapphire','scholar','science','servant','session',
  'shelter','silence','society','soldier','sonnet','species','station','stellar',
  'storage','sublime','support','surplus','synonym','tangent','tension','texture',
  'theorem','tourist','township','tragedy','tsunami','turmoil','twilight','universe',
  'venture','village','vintage','visitor','volcano','voltage','warrior','welfare',
  'whisper','wildfire','windmill','witness','worship',
];

const VERBS = [
  // short (≤4)
  'act','aim','ban','bid','cry','dig','dip','eat','fly','get','hit','hug','jog',
  'lap','lie','mop','nap','nod','pop','put','rap','rip','run','say','set','sew',
  'sit','ski','tap','tie','tip','win','zip',
  // medium (5–8)
  'blend','break','bring','build','burst','carry','catch','chase','cheer','climb',
  'coast','cover','craft','crash','crawl','cross','crush','dodge','doubt','draft',
  'drain','erase','fetch','float','forge','grasp','greet','grind','guard','guide',
  'hatch','haunt','hover','judge','kneel','knock','launch','learn','leave','march',
  'merge','occur','paint','pause','place','plant','plead','pluck','press','prove',
  'raise','reach','rebel','relay','renew','reply','reset','roast','scout','sculpt',
  'shake','shape','share','slide','solve','spawn','speak','spend','split','spray',
  'stand','start','steer','stomp','store','strut','study','surge','swirl','teach',
  'think','throw','track','trade','train','trust','twist','voice','weave','wield',
  // long (9+)
  'abandon','achieve','activate','advance','amplify','analyze','celebrate','collect',
  'combine','command','complete','compose','conceive','conquer','consult','contain',
  'continue','convince','cultivate','dedicate','deliver','develop','discover','display',
  'elaborate','embrace','emerge','empower','encourage','enforce','enhance','enlighten',
  'evolve','examine','execute','explore','express','generate','illuminate','imagine',
  'implement','improve','increase','inspire','integrate','maximize','navigate',
  'overcome','preserve','produce','protect','realize','recognize','recommend',
  'reinforce','represent','research','resolve','restore','struggle','succeed',
  'transform','travel','understand','validate',
];

const ADJECTIVES = [
  // short (≤4)
  'apt','bold','calm','cold','cool','dark','deep','dull','epic','fair','fast',
  'firm','flat','free','glad','grim','huge','idle','keen','kind','lazy','lean',
  'loud','lush','mild','neat','nice','pale','pure','rare','real','rich','ripe',
  'rude','safe','slim','slow','soft','sour','tame','thin','tidy','tiny','torn',
  'true','ugly','vast','vile','warm','wide','wild','wise','worn','zany',
  // medium (5–8)
  'agile','amber','ample','antsy','ashen','bleak','blunt','brave','bright','brisk',
  'broad','civil','clean','clear','crisp','cruel','curly','dense','eager','earthy',
  'eerie','elite','empty','exact','faint','fancy','fiery','fluffy','fresh','frail',
  'funky','fuzzy','gaudy','giddy','gloomy','golden','grand','happy','harsh','hasty',
  'hefty','hollow','honest','humid','ideal','jazzy','joyful','jumpy','large','leafy',
  'lofty','lucky','lumpy','major','matte','meaty','merry','messy','minor','misty',
  'moody','mossy','murky','mushy','noble','noisy','nutty','outer','perky','petty',
  'plain','plump','plush','proud','quick','quirky','rainy','rocky','roomy','rough',
  'round','rowdy','rustic','savvy','scaly','scary','serene','shady','sharp','shiny',
  'silky','sleek','smart','smoky','snappy','solid','spicy','spiky','stark','stiff',
  'stout','suave','sunny','swift','tense','thick','tired','trendy','urban','vivid',
  'wavy','weary','witty','young','zesty',
  // long (9+)
  'abstract','academic','accurate','adaptable','admirable','adventurous','affectionate',
  'ambitious','appealing','authentic','balanced','beautiful','brilliant','captivating',
  'celestial','charismatic','colorful','composed','courageous','creative','decisive',
  'delightful','diligent','dynamic','eccentric','effective','elegant','eloquent',
  'empathetic','enchanting','enduring','energetic','exciting','exquisite','faithful',
  'fantastic','fearless','flexible','formidable','graceful','grateful','genuine',
  'imaginative','impressive','incredible','independent','infinite','insightful',
  'inspiring','intellectual','intuitive','legendary','luminous','magnetic','magnificent',
  'methodical','mindful','mystical','passionate','peaceful','perceptive','playful',
  'polished','positive','powerful','precise','productive','remarkable','resilient',
  'resourceful','scholarly','sensitive','sincere','spirited','spectacular','strategic',
  'stunning','thoughtful','timeless','trustworthy','versatile','vibrant','visionary',
  'wholesome','wonderful',
];

const ADVERBS = [
  'always','barely','boldly','briskly','calmly','closely','coldly','coolly','deeply',
  'dimly','eagerly','easily','evenly','fairly','firmly','fondly','freely','fully',
  'gladly','gently','greatly','harshly','heavily','highly','hugely','justly','keenly',
  'kindly','largely','lately','lazily','likely','loudly','madly','mainly','mildly',
  'mostly','nearly','neatly','nicely','nobly','oddly','often','openly','partly',
  'perhaps','plainly','purely','quietly','quickly','rarely','readily','really',
  'roughly','rudely','safely','slowly','smartly','softly','solely','strongly',
  'swiftly','totally','truly','vastly','vividly','warmly','widely','wisely','wrongly',
  'certainly','clearly','commonly','constantly','currently','directly','effectively',
  'entirely','equally','especially','eventually','exactly','extremely','finally',
  'formally','frequently','generally','genuinely','globally','gradually','honestly',
  'hopefully','instantly','intensely','naturally','obviously','officially','perfectly',
  'personally','physically','positively','possibly','precisely','probably','properly',
  'randomly','rapidly','recently','seemingly','seriously','sharply','simply','sincerely',
  'slightly','sometimes','steadily','typically','ultimately','uniquely','urgently',
  'virtually','wildly','willingly','wonderfully',
];

// ─── Helpers ──────────────────────────────────────────────────────────────────
const NOUN_SET = new Set(NOUNS);
const VERB_SET = new Set(VERBS);
const ADJ_SET  = new Set(ADJECTIVES);
const ADV_SET  = new Set(ADVERBS);

const TYPE_META = {
  noun:      { bg: '#e0f2fe', text: '#0369a1', label: 'noun' },
  verb:      { bg: '#dcfce7', text: '#15803d', label: 'verb' },
  adjective: { bg: '#fef3c7', text: '#b45309', label: 'adj'  },
  adverb:    { bg: '#f3e8ff', text: '#7e22ce', label: 'adv'  },
  word:      { bg: '#f1f5f9', text: '#475569', label: 'word' },
};

function getWordType(word) {
  if (NOUN_SET.has(word)) return 'noun';
  if (VERB_SET.has(word)) return 'verb';
  if (ADJ_SET.has(word))  return 'adjective';
  if (ADV_SET.has(word))  return 'adverb';
  return 'word';
}

function countSyllables(word) {
  word = word.toLowerCase();
  let n = 0, prev = false;
  for (const ch of word) {
    const v = 'aeiou'.includes(ch);
    if (v && !prev) n++;
    prev = v;
  }
  if (word.endsWith('e') && n > 1) n--;
  return Math.max(1, n);
}

const ALL_LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

function buildPool(type, length, starts) {
  let pool =
    type === 'noun'      ? [...NOUNS] :
    type === 'verb'      ? [...VERBS] :
    type === 'adjective' ? [...ADJECTIVES] :
    type === 'adverb'    ? [...ADVERBS] :
    [...NOUNS, ...VERBS, ...ADJECTIVES, ...ADVERBS];

  if (length === 'short')  pool = pool.filter(w => w.length <= 4);
  if (length === 'medium') pool = pool.filter(w => w.length >= 5 && w.length <= 8);
  if (length === 'long')   pool = pool.filter(w => w.length >= 9);
  if (starts !== 'any')   pool = pool.filter(w => w[0] === starts.toLowerCase());
  return pool;
}

// ─── Component ────────────────────────────────────────────────────────────────
export default function RandomWordGenerator() {
  const [count,      setCount]      = useState(10);
  const [length,     setLength]     = useState('any');
  const [wordType,   setWordType]   = useState('any');
  const [startsWith, setStartsWith] = useState('any');
  const [words,      setWords]      = useState([]);
  const [favorites,  setFavorites]  = useState(() => {
    try { return JSON.parse(localStorage.getItem('rwg_favs') || '[]'); } catch { return []; }
  });
  const [copied,    setCopied]    = useState(null);
  const [copiedAll, setCopiedAll] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const [noResults, setNoResults] = useState(false);

  function generate(cnt, len, type, starts) {
    const c = cnt   ?? count;
    const l = len   ?? length;
    const t = type  ?? wordType;
    const s = starts ?? startsWith;
    const pool = buildPool(t, l, s);
    if (!pool.length) { setWords([]); setNoResults(true); return; }
    const shuffled = [...pool].sort(() => Math.random() - 0.5);
    setWords(shuffled.slice(0, Math.min(c, pool.length)));
    setNoResults(false);
  }

  useEffect(() => { generate(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function copyWord(word) {
    navigator.clipboard.writeText(word).then(() => {
      setCopied(word); setTimeout(() => setCopied(null), 1500);
    });
  }

  function copyAll() {
    navigator.clipboard.writeText(words.join('\n')).then(() => {
      setCopiedAll(true); setTimeout(() => setCopiedAll(false), 2000);
    });
  }

  function toggleFav(word) {
    setFavorites(prev => {
      const next = prev.includes(word) ? prev.filter(w => w !== word) : [...prev, word];
      localStorage.setItem('rwg_favs', JSON.stringify(next));
      return next;
    });
  }

  const shareText =
    `✨ Random Words from WordZingo:\n\n${words.map(w => `• ${w}`).join('\n')}\n\n🎯 Generate your own! wordzingo.com/random-word-generator`;

  const btnBase = { borderRadius: 50, fontFamily: 'Nunito, sans-serif', border: '2px solid var(--border)', cursor: 'pointer' };

  return (
    <div className="game-page">
      <PageSEO page="random-word-generator" />
      {showShare && (
        <ShareModal
          shareText={shareText}
          gameUrl="https://wordzingo.com/random-word-generator"
          onClose={() => setShowShare(false)}
          onNewGame={() => generate()}
        />
      )}

      <div className="container" style={{ maxWidth: 740 }}>
        <Link to="/" className="back-btn"><i className="bi bi-arrow-left"></i> All Games</Link>

        <div className="game-header">
          <span className="game-icon">🎲</span>
          <h1>Random Word Generator</h1>
          <p>Generate random English words instantly — filter by type, length, and starting letter!</p>
        </div>

        {/* ── Controls ── */}
        <div style={{ background: '#f8fafc', borderRadius: 16, padding: '1.25rem 1.25rem 0.75rem', marginBottom: '1.25rem', border: '2px solid var(--border)' }}>

          {/* Count */}
          <div className="mb-3">
            <div className="fw-bold mb-2" style={{ fontSize: '0.82rem', color: '#374151' }}>How many words?</div>
            <div className="d-flex gap-2 flex-wrap align-items-center">
              {[1, 5, 10, 20].map(n => (
                <button key={n} onClick={() => { setCount(n); generate(n, length, wordType, startsWith); }}
                  style={{ ...btnBase, minWidth: 48, padding: '0.25rem 0.5rem', fontSize: '0.85rem', fontWeight: 700,
                    background: count === n ? 'var(--primary)' : '#fff',
                    color:      count === n ? '#fff' : '#374151',
                    borderColor: count === n ? 'var(--primary)' : 'var(--border)' }}>
                  {n}
                </button>
              ))}
              <input type="number" min="1" max="50" value={count}
                onChange={e => { const v = Math.max(1, Math.min(50, +e.target.value || 1)); setCount(v); }}
                onKeyDown={e => e.key === 'Enter' && generate()}
                style={{ width: 68, borderRadius: 50, border: '2px solid var(--border)', padding: '0.22rem 0.6rem', fontFamily: 'Nunito, sans-serif', fontSize: '0.85rem', textAlign: 'center' }}
              />
            </div>
          </div>

          {/* Length */}
          <div className="mb-3">
            <div className="fw-bold mb-2" style={{ fontSize: '0.82rem', color: '#374151' }}>Word Length</div>
            <div className="d-flex gap-2 flex-wrap">
              {[['any','Any'],['short','Short (1–4)'],['medium','Medium (5–8)'],['long','Long (9+)']].map(([val, label]) => (
                <button key={val} onClick={() => { setLength(val); generate(count, val, wordType, startsWith); }}
                  style={{ ...btnBase, padding: '0.25rem 0.75rem', fontSize: '0.82rem', fontWeight: 700,
                    background:  length === val ? '#4f46e5' : '#fff',
                    color:       length === val ? '#fff' : '#374151',
                    borderColor: length === val ? '#4f46e5' : 'var(--border)' }}>
                  {label}
                </button>
              ))}
            </div>
          </div>

          {/* Type */}
          <div className="mb-3">
            <div className="fw-bold mb-2" style={{ fontSize: '0.82rem', color: '#374151' }}>Word Type</div>
            <div className="d-flex gap-2 flex-wrap">
              {[['any','Any'],['noun','Nouns'],['verb','Verbs'],['adjective','Adjectives'],['adverb','Adverbs']].map(([val, label]) => (
                <button key={val} onClick={() => { setWordType(val); generate(count, length, val, startsWith); }}
                  style={{ ...btnBase, padding: '0.25rem 0.75rem', fontSize: '0.82rem', fontWeight: 700,
                    background:  wordType === val ? '#059669' : '#fff',
                    color:       wordType === val ? '#fff' : '#374151',
                    borderColor: wordType === val ? '#059669' : 'var(--border)' }}>
                  {label}
                </button>
              ))}
            </div>
          </div>

          {/* Starts With */}
          <div className="mb-2">
            <div className="fw-bold mb-2" style={{ fontSize: '0.82rem', color: '#374151' }}>Starts With</div>
            <select value={startsWith}
              onChange={e => { setStartsWith(e.target.value); generate(count, length, wordType, e.target.value); }}
              style={{ borderRadius: 50, border: '2px solid var(--border)', padding: '0.28rem 1rem', fontFamily: 'Nunito, sans-serif', fontSize: '0.85rem', background: '#fff', cursor: 'pointer' }}>
              <option value="any">Any Letter</option>
              {ALL_LETTERS.map(l => <option key={l} value={l}>{l}</option>)}
            </select>
          </div>
        </div>

        {/* Generate Button */}
        <div className="text-center mb-4">
          <button onClick={() => generate()} className="solve-btn"
            style={{ fontSize: '1.05rem', padding: '0.7rem 2.5rem' }}>
            🎲 Generate Words
          </button>
        </div>

        {/* No results */}
        {noResults && (
          <div className="text-center py-4 mb-4">
            <div style={{ fontSize: '2.5rem' }}>😕</div>
            <p className="fw-bold mt-2" style={{ color: '#64748b' }}>
              No words match your filters. Try adjusting length, type, or starting letter.
            </p>
          </div>
        )}

        {/* Results */}
        {words.length > 0 && (
          <>
            <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
              <span className="fw-bold" style={{ color: '#374151', fontSize: '0.88rem' }}>
                {words.length} word{words.length !== 1 ? 's' : ''} generated
              </span>
              <div className="d-flex gap-2">
                <button onClick={copyAll}
                  style={{ ...btnBase, padding: '0.3rem 0.9rem', fontSize: '0.82rem', fontWeight: 700,
                    background: copiedAll ? '#059669' : '#fff', color: copiedAll ? '#fff' : '#374151',
                    borderColor: copiedAll ? '#059669' : 'var(--border)' }}>
                  {copiedAll ? '✅ Copied!' : '📋 Copy All'}
                </button>
                <button onClick={() => setShowShare(true)}
                  style={{ ...btnBase, padding: '0.3rem 0.9rem', fontSize: '0.82rem', fontWeight: 700, background: '#4f46e5', color: '#fff', borderColor: '#4f46e5' }}>
                  📤 Share
                </button>
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: 10, marginBottom: '1.5rem' }}>
              {words.map((word, i) => {
                const type = getWordType(word);
                const tm   = TYPE_META[type];
                const syls = countSyllables(word);
                const isFav = favorites.includes(word);
                return (
                  <div key={`${word}-${i}`}
                    style={{ background: '#fff', border: '2px solid var(--border)', borderRadius: 14,
                      padding: '0.75rem 0.6rem 0.6rem', textAlign: 'center', position: 'relative' }}>

                    {/* Fav star */}
                    <button onClick={() => toggleFav(word)}
                      title={isFav ? 'Remove from saved' : 'Save word'}
                      style={{ position: 'absolute', top: 5, right: 7, background: 'none', border: 'none', cursor: 'pointer', fontSize: '0.9rem', lineHeight: 1, padding: 0 }}>
                      {isFav ? '⭐' : '☆'}
                    </button>

                    {/* Word */}
                    <div style={{ fontFamily: 'Nunito, sans-serif', fontWeight: 800, fontSize: '1.1rem', color: '#1e293b', marginBottom: 5, letterSpacing: '0.01em', wordBreak: 'break-word' }}>
                      {word}
                    </div>

                    {/* Badges */}
                    <div className="d-flex justify-content-center gap-1 mb-2 flex-wrap">
                      <span style={{ background: tm.bg, color: tm.text, fontSize: '0.62rem', fontWeight: 700, padding: '1px 6px', borderRadius: 99 }}>{tm.label}</span>
                      <span style={{ background: '#f1f5f9', color: '#64748b', fontSize: '0.62rem', fontWeight: 700, padding: '1px 6px', borderRadius: 99 }}>{word.length} lt</span>
                      <span style={{ background: '#f1f5f9', color: '#64748b', fontSize: '0.62rem', fontWeight: 700, padding: '1px 6px', borderRadius: 99 }}>{syls} syl</span>
                    </div>

                    {/* Copy */}
                    <button onClick={() => copyWord(word)}
                      style={{ background: copied === word ? '#dcfce7' : '#f8fafc', border: '1px solid var(--border)',
                        borderRadius: 99, padding: '2px 0', fontSize: '0.7rem', fontWeight: 700, cursor: 'pointer',
                        color: copied === word ? '#15803d' : '#374151', fontFamily: 'Nunito, sans-serif', width: '100%' }}>
                      {copied === word ? '✅ Copied' : '📋 Copy'}
                    </button>
                  </div>
                );
              })}
            </div>
          </>
        )}

        {/* Saved Words */}
        {favorites.length > 0 && (
          <div style={{ background: '#fefce8', border: '2px solid #fde68a', borderRadius: 14, padding: '1rem', marginBottom: '1.5rem' }}>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <span className="fw-bold" style={{ color: '#92400e', fontSize: '0.9rem' }}>⭐ Saved Words ({favorites.length})</span>
              <button onClick={() => { setFavorites([]); localStorage.removeItem('rwg_favs'); }}
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#92400e', fontSize: '0.78rem', fontWeight: 700 }}>
                Clear All
              </button>
            </div>
            <div className="d-flex flex-wrap gap-2">
              {favorites.map(w => (
                <span key={w} style={{ background: '#fff', border: '1.5px solid #fde68a', borderRadius: 99, padding: '3px 10px', fontSize: '0.82rem', fontWeight: 700, color: '#374151', fontFamily: 'Nunito, sans-serif', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                  <span style={{ cursor: 'pointer' }} onClick={() => copyWord(w)} title="Click to copy">{w}</span>
                  <span style={{ color: '#d97706', cursor: 'pointer', fontSize: '1rem', lineHeight: 1 }} onClick={() => toggleFav(w)}>×</span>
                </span>
              ))}
            </div>
            <p style={{ fontSize: '0.72rem', color: '#92400e', marginTop: 8, marginBottom: 0 }}>
              Click any word to copy it · × to remove · Saved between sessions
            </p>
          </div>
        )}

        <SeoContent game="random-word-generator" />
      </div>
    </div>
  );
}
